import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=9d4a99bc&scoped=true&"
import script from "./VideoControl.vue?vue&type=script&lang=js&"
export * from "./VideoControl.vue?vue&type=script&lang=js&"
import style0 from "./VideoControl.vue?vue&type=style&index=0&id=9d4a99bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4a99bc",
  null
  
)

export default component.exports